$(function () {
	const TOP_OFFSET = 100;

	$('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function (e) {
		if (
			location.pathname.replace(/^\//, "") === this.pathname.replace(/^\//, "")
			&& location.hostname === this.hostname
		) {
			let s = $(this.hash);
			(s = s.length ? s : $("[name=" + this.hash.slice(1) + "]")).length && (e.preventDefault(),
				$("html, body").animate({
					scrollTop: s.offset().top - TOP_OFFSET
				}, 1e3))
		}
	});

	const initPageNavMenu = () => {
		const $pageMenu = $('.b-page-nav');
		const isEditorMode = $('.landing-edit-mode').length > 0;

		if ($pageMenu.length === 0 || isEditorMode) {
			return;
		}

		let pageSectionsHash = $('.b-page-nav__link', $pageMenu).map(function () {
			$(this).data('nav', this.hash);

			return this.hash.length > 0 && this.hash;
		}).toArray();

		// Проверка на валидность селектора
		pageSectionsHash = pageSectionsHash.filter((item) => isNaN(parseInt(item.substring(1))));

		const pageSections = [...document.querySelectorAll(pageSectionsHash.join(','))];

		if (!pageSections.length) {
			return false;
		}

		$(window).on('scroll load', (e) => {
			const FirstSection = pageSections[0];
			const lastSection = pageSections[pageSections.length - 1];

			const scrolledSection = pageSections.filter(function (section) {
				return section.getBoundingClientRect().top - TOP_OFFSET * 1.05 <= 0;
			});

			let current = FirstSection;

			if (scrolledSection.length) {
				current = scrolledSection[scrolledSection.length - 1]
			}

			// проверка на видимость последнего элемента
			if (lastSection.getBoundingClientRect().bottom - window.innerHeight < TOP_OFFSET * 1.05) {
				current = lastSection
			}

			if (current) {
				const id = current.getAttribute('id');
				$('.b-page-nav__link', $pageMenu).removeClass('is-active');
				$(`.b-page-nav__link[href*="#${id}"]`, $pageMenu).addClass('is-active');
			}
		});

		let closeTimeout;

		$pageMenu.on('mouseover', function (e) {
			$pageMenu.addClass('is-open');
			$('.b-page-nav__list').off('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend');
			clearTimeout(closeTimeout);
		});

		$pageMenu.on('mouseleave', function () {
			$('.b-page-nav__list').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
				closeTimeout = setTimeout(() => {
					$pageMenu.removeClass('is-open');
				}, 200)
			})
		})
	};

	initPageNavMenu();

	$(document).on('click', '.b-page-nav__toggle', function (e) {
		const $parentItem = $(this).closest('.b-page-nav');
		const $list = $('.b-page-nav__list', $parentItem);

		$list.slideToggle();
		$(this).toggleClass('is-opened');
	});
});
